<template>
    <div class="card">
        <div class="card-header p-0" id="headingFeatureable">
            <a
                class="btn btn-block text-left p-3"
                data-toggle="collapse"
                role="button"
                href="#collapseFeatureable"
                aria-expanded="false"
                aria-controls="collapseFeatureable">
                <h6 class="mb-0">{{ $t(`${modelTranslateID}.title`) }}</h6>
            </a>
        </div>

        <div id="collapseFeatureable"
            class="collapse"
            aria-labelledby="headingFeatureable"
            data-parent="">
            <div class="card-body">
                <div class="row">

                    <div class="col-12 col-sm-auto align-self-sm-center mb-3">
                        <div class="form-group">
                            <div class="form-check city-form-check pl-0">
                                <input
                                    class="form-check-input"
                                    type="checkbox"
                                    :id="`cb-featureable`"
                                    :name="`cb-featureable`"
                                    :disabled="readonlyForm || !this.hasResources"
                                    v-model="form.status"
                                    :false-value="false"
                                    :true-value="true"
                                    v-validate="''"
                                    :data-vv-scope="vScope">
                                <label class="form-check-label h-auto" :for="`cb-featureable`">
                                    <div class="d-flex flex-column align-items-start">
                                        <strong>{{ $t(`${modelTranslateID}.form.status`) }}</strong>
                                    </div>
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm">
                        <div class="form-group">
                            <MaterialInput
                                :readonly="disableField"
                                :disabled="disableField"
                                class="city-form-group city-bg"
                                id="input-integration-id"
                                name="integration-id"
                                v-model.trim="form.integration_id"
                                v-validate="{required: form.status}"
                                :data-vv-scope="vScope"
                                :inputClasses="[{'is-invalid': fnHasError('integration-id', vScope) }]"
                                :error="fnFirstError('integration-id', vScope)">
                                {{ $t(`${modelTranslateID}.form.integration_id`) }}
                            </MaterialInput>
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <MaterialSelect
                                :disabled="disableField"
                                class="city-form-group city-bg"
                                id="input-acl-code"
                                name="acl-code"
                                label="name"
                                :options="acls"
                                v-model.trim="form.acl_code"
                                :reduce="option => option.code"
                                v-validate="''"
                                :data-vv-scope="vScope"
                                :inputClasses="[{'is-invalid': fnHasError('acl-code', vScope) }]"
                                :error="fnFirstError('acl-code', vScope)">
                                {{ $t(`${modelTranslateID}.form.acl_code`) }}
                            </MaterialSelect>
                        </div>
                    </div>
                </div>

                <div class="row" v-if="subtypes.length">
                    <div class="col-12">
                        <LayerSubtype
                            v-model="form.subtypes"
                            :idPanel="idPanel"
                            :idSubPanel="`${idSubPanel}.subtypes`"
                            :panelCfg="panelCfg"
                            :baseTranslateID="baseTranslateID"
                            :vScope="vScope"
                            :readonlyForm="disableField"
                            :subtypes="subtypes"
                        />
                    </div>
                </div>

                <div class="row" v-if="showConfig">
                    <div class="col-12">
                        <div class="row">
                            <div class="col">
                                <h6 class="font-weight-normal">{{ $t(`${modelTranslateID}.form.group`) }}</h6>
                                <hr class="mt-2" />
                            </div>
                        </div>
                    </div>

                    <div class="col-12">
                        <div class="row">
                            <div
                                class="col-sm"
                                v-for="(typename, idx) in (form.typenames ?? [])"
                                :key="`typename-${idx}`">
                                <LayerTypenameForm
                                    v-model="form.typenames[idx]"
                                    :idx="idx"
                                    :vScope="vScope"
                                    :parendId="idSubPanel"
                                    :readonlyForm="readonlyForm"
                                    :baseTranslateID="baseTranslateID"
                                    :showFieldId="true"
                                    :showFieldName="true"
                                    @onReset="onResetProperties(typename)"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ElementMixin from '../mixins/ElementMixin';
import TypenameMixin from '../mixins/TypenameMixin';

export default {
    name: 'LayerFeatureable',
    mixins: [
        ElementMixin,
        TypenameMixin,
    ],
    components: {
        LayerTypenameForm: () => import(/* webpackChunkName: "recursive-details-layer-typenames" */ './LayerTypenameForm.vue'),
        LayerSubtype: () => import(/* webpackChunkName: "recursive-details-layer-subtypes" */ './LayerSubtype'),
    },
    props: {
        value: {
            type: Object,
            default: () => {
                return {};
            },
        },
        idSubPanel: {
            type: String,
            default: 'featureable',
        },
        acls: {
            type: Array,
            default: () => [],
        },
        subtypes: {
            type: Array,
            default: () => [],
        },
    },
    defaultObj: {
        id: null,
        status: false,
        integration_id: null,
        acl_code: null,
        subtypes: [],
        typenames: [],
    },
    data() {
        return {
            form: this.$options.defaultObj,
        }
    },
    computed: {
        isActive() {
            return  this.form?.status ?? false;
        },
        showConfig() {
            return  (this.form?.typenames ?? []).length>0;
        },
    },
    methods:{

    },

}
</script>